import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import HomePageElgiganten from "branchAndBrandSpecific/features/home/home.elgiganten";
import { NewsOverview } from "../news";
import HomePageLogitech from "@/pages/Home/HomePageLogitech";
import F1Challenge from "@/pages/Challenges/F1Challenge";

const HomePage: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Welcome - Home");

  // During LiveStream we don't have a home page
  if (brand.brandValue === "ELGIGANTEN") {
    return <HomePageElgiganten />;
  }

  // During LiveStream we don't have a home page
  if (brand.brandValue === "LOGITECH") {
    return <HomePageLogitech />;
  }

  if (brand.brandValue === "DBG") {
    return <NewsOverview />; // Change to HomePageDBG when ready
  }

  if (brand.brandValue === "LEGO") {
    return <F1Challenge />;
  }

  return <div className="home"></div>;
};

export default HomePage;
